<template>
  <studio-team>
    <template #card-image>
      <div class="boder-image-circle">
        <img
          alt="user logo"
          class="image-avatar"
          :src="userImage"
        >
      </div>
    </template>
    <template #card-details>
      <div class="md-layout md-alignment-center-center user-name"> 
        <h1 v-html="title" />
      </div>
      <div class="md-layout md-alignment-center-center studio-name"> 
        <p v-html="studioMaster" />
      </div>
    </template>
  </studio-team>
</template>
<script>
import StudioTeam from './StudioTeam'
export default {
  name: "StudioArtist",
  components: {
    StudioTeam
  },
  props: {
    title: {
      type: String,
      required: true
    },
    studioMaster: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: true
    }
  },
  computed: {
    userImage () {
      return this.image.length ? this.image : require('@/assets/avatar.svg')
    }
  }
}
</script>
<style lang="scss" scoped>
.user-name {
  h1 {
    margin-bottom: 0;
  }
}
.boder-image-circle {
  padding: 0px 10px 0px 10px;
}
.studio-name {
  font-size: 14px;
  line-height: 1.71;
  text-align: center;
  color: #a1aeb7;
  margin-top: -10px;
  margin-bottom: -10px;
}
a {
  cursor: pointer;
}
</style>